import styled from 'styled-components'

export const FormContentStepThree = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
